import { ActorCalendar } from "./Scheduling.types";
import { ActorCalendarService } from "./ActorCalendarService";
import { IdentityResolutionService } from "./IdentityResolutionService";

export class UserSchedulesService {
  constructor(
    private readonly identityResolutionService: IdentityResolutionService,
    private readonly actorCalendarService: ActorCalendarService,
  ) {}

  async getForEmail(email: string): Promise<ActorCalendar> {
    const actors = await this.identityResolutionService.resolveByEmail(email);
    return this.actorCalendarService.getForActors(actors);
  }
}
